import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { FaArrowLeft, FaCalendarAlt } from "react-icons/fa";
import { IoIosArrowDown, IoIosCheckmarkCircleOutline } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { debounce, isEmpty, startCase, upperCase } from "lodash";
import InternalLoader from "../../component/InternalLoader";
import GameRecordFilter from "./GameRecordFilter";
import { toFixedWithoutRounding } from "../../Utils/Toast";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
const ProfitLoss = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [active, setActive] = useState({});
  const [show, setShow] = useState({
    status: false,
    type: "",
  });
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    fromPeriod: moment().format("YYYY-MM-DD HH:mm:ss"),
    toPeriod: moment().format("YYYY-MM-DD HH:mm:ss"),
    betType: "BetFair",
    status: "completed",
    tab: "sports",
  });
  const profileData = useContextSelector(AuthContext, (ctx) => ctx.profileData);

  const from = moment(filter?.fromPeriod);
  const to = moment(filter?.toPeriod);

  // 1️⃣ Check if both are today
  const isToday = from.isSame(moment(), "day") && to.isSame(moment(), "day");

  // 2️⃣ Check if range is last 7 days (including today)
  const isLast7Days =
    from.isSame(moment().subtract(6, "days"), "day") &&
    to.isSame(moment(), "day");

  // 3️⃣ Check if both are yesterday
  const isYesterday =
    from.isSame(moment().subtract(1, "day"), "day") &&
    to.isSame(moment().subtract(1, "day"), "day");
  const format = "YYYY-MM-DD HH:mm:ss";

  const setToday = () => {
    return {
      fromPeriod: moment().startOf("day").format(format),
      toPeriod: moment().endOf("day").format(format),
    };
  };

  const setYesterday = () => {
    return {
      fromPeriod: moment().subtract(1, "day").startOf("day").format(format),
      toPeriod: moment().subtract(1, "day").endOf("day").format(format),
    };
  };

  const setLast7Days = () => {
    return {
      fromPeriod: moment().subtract(6, "days").startOf("day").format(format),
      toPeriod: moment().endOf("day").format(format),
    };
  };
  let dummy = {
    BetFair: "betfair",
    Bookmaker: "bookmaker",
    Fancy: "fancy",
    SportsBook: "sportBook",
  };
  const getData = async (obj = filter) => {
    const { status, data } = await apiGet(apiPath.profitLoss, {
      betType: obj?.tab == "Casino" ? "casino" : dummy[obj?.betType],
      status: "completed",
      fromPeriod: moment(obj?.fromPeriod).format("YYYY-MM-DD"),
      toPeriod: moment(obj?.toPeriod).format("YYYY-MM-DD"),
      page: obj?.page || 1,
      limit: obj?.limit,
    });
    if (status == 200) {
      if (data?.success) {
        setData(
          obj?.tab == "Casino"
            ? data?.results?.data
            : data?.results?.data
                .filter((res) => {
                  return res?.bets_list?.length > 0;
                })
                ?.map((res) => {
                  return {
                    ...res,
                    total: calculateTotal(res, dummy[filter?.betType]),
                  };
                })
        );
      }
    }
    setLoader(false);
  };

  const calculateTotal = (markets, newTab) => {
    if (!Array.isArray(markets?.bets_list) || markets?.bets_list.length === 0)
      return 0;

    const commissionRate = parseFloat(profileData?.commission) || 0;

    let backProfit = 0,
      backLoss = 0,
      layProfit = 0,
      layLoss = 0,
      yesProfit = 0,
      yesLoss = 0,
      noProfit = 0,
      noLoss = 0,
      totalBet = 0;
    // ✅ Process each bet & add updatedResult
    markets?.bets_list?.forEach((bet) => {
      const profit = parseFloat(bet.profitAmount) || 0;
      const loss = parseFloat(bet.loseAmount) || 0;
      totalBet = +parseFloat(bet?.amount) || 0;
      let updateResultValue = 0;

      // 🎯 Back / Lay Bets (Exchange)
      if (bet?.betType === "back") {
        if (bet?.teamSelectionWin === bet?.selectionId) {
          backProfit += profit;
          updateResultValue = profit; // Win
        } else {
          backLoss += loss;
          updateResultValue = -loss; // Loss
        }
      } else if (bet?.betType === "lay") {
        if (bet?.teamSelectionWin !== bet?.selectionId) {
          layProfit += profit;
          updateResultValue = profit; // Win
        } else {
          layLoss += loss;
          updateResultValue = -loss; // Loss
        }
      }

      // 🎯 Fancy Yes / No Bets
      if (bet?.type === "Yes") {
        if (bet?.decisionRun >= bet?.betRun) {
          yesProfit += profit;
          updateResultValue = profit; // Win
        } else {
          yesLoss += loss;
          updateResultValue = -loss; // Loss
        }
      } else if (bet?.type === "No") {
        if (bet?.decisionRun < bet?.betRun) {
          noProfit += profit;
          updateResultValue = profit; // Win
        } else {
          noLoss += loss;
          updateResultValue = -loss; // Loss
        }
      }

      // ✅ Add single key for result
      return {
        ...bet,
        updatedResult: updateResultValue,
      };
    });

    // 🎯 Calculate subtotals
    const backSubTotal = backProfit - backLoss;
    const laySubTotal = layProfit - layLoss;
    const marketSubTotal = backSubTotal + laySubTotal;

    const yesSubTotal = yesProfit - yesLoss;
    const noSubTotal = noProfit - noLoss;
    const fancySubTotal = yesSubTotal + noSubTotal;

    // 🎯 Calculate Net Amount based on Tab
    let netAmount = 0;
    if (newTab === "toss" || newTab === "tie") {
      netAmount = marketSubTotal;
    } else if (newTab === "fancy") {
      netAmount = fancySubTotal;
    } else {
      const commission =
        marketSubTotal > 0 ? (marketSubTotal * commissionRate) / 100 : 0;
      netAmount = marketSubTotal - commission;
    }

    return { pl: netAmount, totalBet: totalBet };
  };

  const debouncedFetch = useCallback(
    debounce((obj) => {
      getData(obj);
    }, 500), // wait 600ms
    []
  );
  useEffect(() => {
    setLoader(true);
    debouncedFetch(filter);
  }, [filter]);
  let obj = {
    4: "Cricket",
    2: "Tennis",
    1: "Soccer",
    3: "Casino",
  };
  const ShowPrice = (res) => {
    if (isEmpty(res?.fancyName)) {
      if (
        (res?.teamSelectionWin == res?.selectionId && res?.betType == "back") ||
        (res?.teamSelectionWin != res?.selectionId && res?.betType == "lay")
      ) {
        return res?.profitAmount;
      } else {
        return -res?.loseAmount;
      }
    } else {
      if (res?.type == "No") {
        if (res?.decisionRun < res?.betRun) {
          return res?.profitAmount;
        } else {
          return -res?.loseAmount;
        }
      } else {
        if (res?.decisionRun >= res?.betRun) {
          return res?.profitAmount;
        } else {
          return -res?.loseAmount;
        }
      }
    }
  };

  return (
    <div
      id="mc-animate-container"
      className="v-base v-detail-base fade-enter-done"
    >
      <div className="time-zone-container">
        <div className="time-zone-tips">
          <svg className="am-icon am-icon-warn_0e789534 am-icon-xs warn-icon">
            <use xlinkHref="#warn_0e789534" />
          </svg>
          Reminder: The data above is based on GMT + 8
        </div>
        <div className="mc-profitLoss-record-root">
          <div className="mc-header-wrap">
            <div
              id="mc-header"
              className="mc-navbar-blue mc-profitandloss mc-default-header am-navbar am-navbar-light"
            >
              <div
                onClick={() => navigate(-1)}
                className="am-navbar-left"
                role="button"
              >
                <span className="am-navbar-left-content">
                  <span className="return_icon">
                    <svg
                      style={{ color: "black" }}
                      className="am-icon am-icon-left am-icon-lg"
                    >
                      <use xlinkHref="#left" />
                    </svg>
                  </span>
                </span>
              </div>
              <div className="am-navbar-title">Personal Report</div>
              <div className="am-navbar-right" />
            </div>
            <div className="am-whitespace am-whitespace-sm mc-whitespace" />
          </div>

          <div className="mc-filter-container" style={{ position: "relative" }}>
            <div className="am-flexbox am-flexbox-align-middle mc-trans-filter  mc-filter ">
              <div className="am-flexbox am-flexbox-align-middle mc-trans-filter ">
                <a
                  onClick={() =>
                    setFilter((prev) => {
                      return {
                        ...prev,
                        fromPeriod: setToday()?.fromPeriod,
                        toPeriod: setToday()?.toPeriod,
                      };
                    })
                  }
                  role="button"
                  className={`am-button ${
                    isToday ? "am-button-primary" : "am-button-ghost"
                  }  am-button-small am-button-inline am-button-icon`}
                  aria-disabled="false"
                >
                  {isToday && (
                    <IoIosCheckmarkCircleOutline
                      size={16}
                      style={{ marginRight: "4px" }}
                    />
                  )}
                  <span>Today</span>
                </a>
                {/* <a
                  onClick={() =>
                    setFilter((prev) => {
                      return {
                        ...prev,
                        fromPeriod: setYesterday()?.fromPeriod,
                        toPeriod: setYesterday()?.toPeriod,
                      };
                    })
                  }
                  role="button"
                  className={`am-button ${
                    isYesterday ? "am-button-primary" : "am-button-ghost"
                  }  am-button-small am-button-inline am-button-icon`}
                  aria-disabled="false"
                >
                  {" "}
                  {isYesterday && (
                    <IoIosCheckmarkCircleOutline
                      size={16}
                      style={{ marginRight: "4px" }}
                    />
                  )}
                  <span>Yesterday</span>
                </a> */}
                <a
                  onClick={() =>
                    setFilter((prev) => {
                      return {
                        ...prev,
                        fromPeriod: setLast7Days()?.fromPeriod,
                        toPeriod: setLast7Days()?.toPeriod,
                      };
                    })
                  }
                  role="button"
                  className={`am-button ${
                    isLast7Days ? "am-button-primary" : "am-button-ghost"
                  }  am-button-small am-button-inline am-button-icon`}
                  aria-disabled="false"
                >
                  {" "}
                  {isLast7Days && (
                    <IoIosCheckmarkCircleOutline
                      size={16}
                      style={{ marginRight: "4px" }}
                    />
                  )}
                  <span>7-days</span>
                </a>

                <div
                  onClick={() =>
                    setShow({
                      status: true,
                      type: "range",
                    })
                  }
                  className="flex-shrink1 filter-time-btn"
                >
                  <a
                    role="button"
                    className="am-button am-button-ghost am-button-small am-button-inline am-button-icon"
                    aria-disabled="false"
                    style={{
                      "-webkit-flex": "0 0 50%",
                      "-ms-flex": "0 0 50%",
                      flex: "0 0 50%",
                    }}
                  >
                    <FaCalendarAlt className="am-icon am-icon-calendar_c4db3b67 am-icon-xxs" />
                    <span>
                      {" "}
                      {moment(filter?.fromPeriod).format("MM/DD")}-{" "}
                      {moment(filter?.toPeriod).format("MM/DD")}
                    </span>
                  </a>
                </div>
                {filter?.tab != "Casino" && (
                  <a
                    onClick={() =>
                      setShow({
                        status: true,
                        type: "vendor",
                      })
                    }
                    role="button"
                    className="vasslage-btn am-button am-button-ghost am-button-small am-button-inline am-button-icon"
                    aria-disabled="false"
                  >
                    <IoIosArrowDown className="am-icon am-icon-down am-icon-xxs" />
                    <span>{filter?.betType}</span>
                  </a>
                )}
              </div>
            </div>{" "}
            <div className="am-tabs am-tabs-top i18n-fix mc-tabs-scroll">
              <div className="mc-tab-container" id="mc-tab-container">
                <div
                  style={{ padding: "8px", fontSize: "14px" }}
                  onClick={() => {
                    setData([]);
                    setFilter((prev) => {
                      return { ...prev, tab: "Casino" };
                    });
                  }}
                  className={`${
                    filter?.tab == "Casino" ? "tab-active" : ""
                  }  mc-tab-item`}
                >
                  <span>Casino</span>
                </div>
                <div
                  style={{ padding: "8px", fontSize: "14px" }}
                  onClick={() => {
                    setData([]);
                    setFilter((prev) => {
                      return { ...prev, tab: "sports" };
                    });
                  }}
                  className={`${
                    filter?.tab == "sports" ? "tab-active" : ""
                  }  mc-tab-item`}
                >
                  <span>Sports</span>
                </div>
              </div>
            </div>
          </div>
          <div className="padding-bottom-2rem" style={{ overflow: "hidden" }}>
            <div
              className="gameCecords-list-root"
              style={{ background: "rgb(245, 245, 245)" }}
            />
            <div className="list-wrapper">
              {isEmpty(active) ? (
                <ul
                  style={{ paddingTop: "80px" }}
                  className="scroll-inner-container"
                >
                  {data?.length > 0 ? (
                    data?.map((res) => {
                      return (
                        <li>
                          <div className="lott-records-root">
                            <div className="records-item-header-sy">
                              <div
                                className="am-flexbox am-flexbox-dir-row am-flexbox-justify-between am-flexbox-align-middle"
                                style={{
                                  height: "0.5rem",
                                  width: "100%",
                                }}
                              >
                                {filter?.tab != "Casino" && (
                                  <div className="am-flexbox am-flexbox-dir-row am-flexbox-align-middle">
                                    <i
                                      style={{
                                        width: "0.2rem",
                                        height: "0.2rem",
                                        marginRight: "0.2rem",
                                        display: "inline-block",
                                        borderRadius: "50%",
                                        background: "rgb(16, 142, 233)",
                                      }}
                                    />
                                    <div
                                      className="mc_common_overflow"
                                      style={{ fontWeight: 600 }}
                                    >
                                      Total Bet : {res?.bets_list?.length}
                                    </div>
                                  </div>
                                )}
                                <div
                                  className="record_date"
                                  style={{ fontSize: "0.26rem" }}
                                >
                                  {moment(res?.timeInserted).format(
                                    "YYYY-MM-DD hh:mm:ss"
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="records-item-content-sy">
                              <div className="am-flexbox am-flexbox-justify-between am-flexbox-align-top">
                                <span>
                                  Event Name:
                                  <span className="order-number-group">
                                    <span className="title">
                                      {res?.eventName || res?.casinoName} |{" "}
                                      {obj[res?.eventType] || res?.platform} |{" "}
                                      {filter?.tab == "Casino"
                                        ? upperCase(res?.casinoType)
                                        : filter?.betType == "BetFair"
                                        ? res?.market
                                        : startCase(filter?.betType)}
                                    </span>
                                  </span>
                                </span>{" "}
                              </div>

                              <div className="am-flexbox am-flexbox-justify-between am-flexbox-align-middle">
                                <span>Bet amount : {res?.total?.totalBet}</span>
                              </div>
                              <div className="am-flexbox am-flexbox-dir-row am-flexbox-justify-between am-flexbox-align-middle">
                                <div className="am-flexbox am-flexbox-dir-column am-flexbox-justify-between am-flexbox-align-top">
                                  <span className="time">Profit and loss</span>
                                  <span
                                    className={`${
                                      (filter?.tab == "Casino"
                                        ? toFixedWithoutRounding(res?.playerPL)
                                        : res?.total?.pl) > 0
                                        ? "loss-amount"
                                        : "win-amount"
                                    }  record-amount`}
                                  >
                                    {filter?.tab == "Casino"
                                      ? toFixedWithoutRounding(res?.playerPL)
                                      : Math.abs(res?.total?.pl)}
                                  </span>
                                </div>{" "}
                                {filter?.tab != "Casino" && (
                                  <div
                                    onClick={() => setActive(res)}
                                    className="am-flexbox am-flexbox-dir-column am-flexbox-justify-between am-flexbox-align-top"
                                  >
                                    <span
                                      style={{
                                        color: "#108ee9",
                                        textDecoration: "underline",
                                      }}
                                      className="record-amount"
                                    >
                                      View Bets
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </li>
                      );
                    })
                  ) : (
                    <div
                      className="nodata-container"
                      style={{ height: "607.609px" }}
                    >
                      <svg className="am-icon am-icon-nodata_f4c19c2d am-icon-md nodata-icon">
                        <use xlinkHref="#nodata_f4c19c2d" />
                      </svg>
                      <p className>No data</p>
                    </div>
                  )}
                </ul>
              ) : (
                <ul
                  style={{ paddingTop: "80px" }}
                  className="scroll-inner-container"
                >
                  <div
                    onClick={() => setActive({})}
                    style={{
                      color: "rgb(16, 142, 233)",
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      paddingLeft: "27px",
                      marginBottom: "10px",
                      paddingBottom: "10px",
                      borderBottom: "1px solid #ebebeb",
                    }}
                  >
                    <FaArrowLeft style={{ marginRight: "5px" }} /> Back
                  </div>
                  {active?.bets_list?.map((res) => {
                    return (
                      <li>
                        <div className="lott-records-root">
                          <div className="records-item-header-sy">
                            <div
                              className="am-flexbox am-flexbox-dir-row am-flexbox-justify-between am-flexbox-align-middle"
                              style={{
                                height: "0.5rem",
                                width: "100%",
                              }}
                            >
                              <div className="am-flexbox am-flexbox-dir-row am-flexbox-align-middle">
                                <i
                                  style={{
                                    width: "0.2rem",
                                    height: "0.2rem",
                                    marginRight: "0.2rem",
                                    display: "inline-block",
                                    borderRadius: "50%",
                                    background: "rgb(16, 142, 233)",
                                  }}
                                />
                                <div
                                  className="mc_common_overflow"
                                  style={{ fontWeight: 600 }}
                                >
                                  {res?.teamName ||
                                    res?.fancyName ||
                                    res?.casinoName}
                                </div>
                              </div>
                              <div
                                className="record_date"
                                style={{ fontSize: "0.26rem" }}
                              >
                                {moment(res?.timeInserted).format(
                                  "YYYY-MM-DD hh:mm:ss"
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="records-item-content-sy">
                            {/* <div className="am-flexbox am-flexbox-justify-between am-flexbox-align-top" /> */}
                            <div className="am-flexbox am-flexbox-justify-between am-flexbox-align-top">
                              <span>
                                Event Name:
                                <span className="order-number-group">
                                  <span className="title">
                                    {res?.matchName || res?.casinoName} |{" "}
                                    {obj[res?.eventType] || res?.platform} |{" "}
                                    {filter?.tab == "Casino"
                                      ? upperCase(res?.casinoType)
                                      : filter?.betType == "BetFair"
                                      ? "Match Odds"
                                      : startCase(filter?.betType)}
                                  </span>
                                </span>
                              </span>{" "}
                            </div>
                            <div className="am-flexbox am-flexbox-justify-between am-flexbox-align-top">
                              <span>
                                Order no.:
                                <span className="order-number-group">
                                  <span className="title">
                                    {res?.matchBetId || res?.casinoBetId}
                                  </span>
                                </span>
                              </span>
                            </div>
                            <div className="am-flexbox am-flexbox-justify-between am-flexbox-align-middle">
                              <span>
                                Bet amount : {res?.amount || res?.betAmount}
                              </span>
                              {filter?.tab != "Casino" && (
                                <span>Odds : {res?.bhav}</span>
                              )}
                            </div>
                            <div className="am-flexbox am-flexbox-dir-row am-flexbox-justify-between am-flexbox-align-middle">
                              <div className="am-flexbox am-flexbox-dir-column am-flexbox-justify-between am-flexbox-align-top">
                                <span className="time">Profit and loss</span>

                                <span
                                  className={`${
                                    (filter?.tab == "Casino"
                                      ? toFixedWithoutRounding(res?.playerPL)
                                      : ShowPrice(res)) > 0
                                      ? "loss-amount"
                                      : "win-amount"
                                  }  record-amount`}
                                >
                                  {filter?.tab == "Casino"
                                    ? toFixedWithoutRounding(res?.playerPL)
                                    : Math.abs(ShowPrice(res))}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              )}
              <div className="pullup-wrapper" />
            </div>
          </div>
        </div>
      </div>{" "}
      {show?.status && !isEmpty(show?.type) && (
        <GameRecordFilter
          type={show?.type}
          setFilter={setFilter}
          setShow={setShow}
          filter={filter}
          page={"history"}
        />
      )}
      {loader && <InternalLoader />}
    </div>
  );
};

export default ProfitLoss;
